import {format} from "date-fns";
import type {DateType} from "react-native-ui-datepicker";

export function getDate(date: DateType) {
    if (!date) {
        return undefined;
    }

    if (typeof date === "object") {
        if (date instanceof Date) {
            return date;
        }
        return date.toDate();
    }

    return new Date(date);
}

export const formatDateRange = (startDate: Date, endDate: Date) => {
    let dateRange = "";
    if (format(startDate, "MMM") === format(endDate, "MMM")) {
        dateRange = `${format(startDate, "MMM d")} - ${format(endDate, "d, y")}`;
    } else {
        dateRange = `${format(startDate, "MMM d")} - ${format(endDate, "MMM d, y")}`;
    }

    return dateRange;
};
